export const commonLb = {
  nav: {
    story: 'Eis Geschicht',
    community: 'Gemeinschaft',
    transformation: 'Transformatioun',
    safety: 'Sécherheet',
    blog: 'Blog',
    shop: 'Buttek',
    donate: 'Ënnerstëtzen',
    volunteer: 'Fräiwëlleg',
    resources: 'Ressourcen',
    crisisTracker: 'Krisetracker',
    partners: 'Partner',
    successStories: 'Erfolleggeschichten',
  },
  // Navigation
  home: "Heem",
  myStory: "Meng Geschicht",
  community: "Gemeinschaft",
  shop: "Buttek",
  blog: "Blog",
  
  // Common buttons
  readMore: "Méi Liesen",
  learnMore: "Méi Wëssen",
  joinNow: "Elo Matmaachen",
  shopNow: "Elo Kafen",
  subscribe: "Abonnéieren",
  submit: "Schécken",
  
  // Footer
  quickLinks: "Séier Linken",
  contact: "Kontakt",
  followUs: "Follegt Eis",
  allRightsReserved: "All Rechter reservéiert",
  
  // Newsletter
  newsletterTitle: "Gitt Mat Bei Eiser Gemeinschaft",
  newsletterSubtitle: "Kritt wëchentlech Inspiratioun an Updates an Ärem Postfach",
  emailPlaceholder: "E-Mail aginn",
  
  // Common phrases
  byAuthor: "Vun"
};

export default commonLb;
